import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardHeader, Col, Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchTodays } from '../../actions/today';
import DataTable from '../../components/data-table';

const COLUMNS = [
  {
    id: 'date', label: 'Date', link: true, sort: -1,
  },
  { id: 'id', label: 'ID', link: true },
];

const Todays = (props) => {
  const { getTodays } = props;
  return (
    <div className="animated fadeIn">
      <Row>
        <Col xl={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col lg={4}>
                    Today
                </Col>
                <Col lg={8} style={{ textAlign: 'right' }}>
                  <Button href="/#/today/new" color="success" size="sm">New</Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <DataTable
                resource="todays"
                dataSource={getTodays}
                columns={COLUMNS}
                urlSchema="today"
                {...props}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Todays.propTypes = {
  getTodays: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  todays: PropTypes.arrayOf(PropTypes.object),
};

Todays.defaultProps = {
  todays: [],
};

const mapStateToProps = ({ today }) => ({
  loading: today.loading,
  todays: today.items,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getTodays: sort => fetchTodays(sort),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Todays);
